module.exports = __webpack_public_path__ + "img/img(17).1bb47e88.jpg";